import { AxiosRequestConfig } from 'axios';
import { useMutation } from 'react-query';
import { isDataLineSearchFormEmpty } from 'src/components/Common/UI/SydFilter/SydFilterTypeChecker';
import { filterNonEmptyValues } from 'src/helpers/AppCode';
import { axiosDefaultApi } from 'src/lib/axios'
import { MutationConfig} from 'src/lib/react-query';
import useNotification from 'src/store/Notifications/useNotification';

const header: AxiosRequestConfig = {responseType: "arraybuffer"}

const mapFilterData = (data: IDataLineSearchForm): IDataLineSearchForm | {} => {
  const newData: IDataLineSearchForm = {...data};
  if (isDataLineSearchFormEmpty(data) || data == undefined) { return {} };

  const removedUnusedFilters = filterNonEmptyValues(newData);
  return removedUnusedFilters;
}

const getLineDownloadCsv = ( {data} : {data: IDataLineSearchForm}): Promise<string> => {
  const filterData = mapFilterData(data);
  const deleted = data.deleted ? data.deleted : false;

  return axiosDefaultApi.post(`api/Search/ExportToCSV/DataLines?pageNumber=1&pageSize=5000&deleted=${deleted}`, filterData, header);
};

type QueryFnType = typeof getLineDownloadCsv;

type UseLineDownloadCsvOptions = {
  data: IDataLineSearchForm;
  config?: MutationConfig<QueryFnType>;
};

export const useLineDownloadCsv = ({ config }: UseLineDownloadCsvOptions) => {
  const {addNotification, setIsNotificationVisible} = useNotification();

  return useMutation({
    onError: (error: any) => {
      addNotification(`Υπήρξε κάποιο πρόβλημα στο κατέβασμα του αρχείου των γραμμών Data.`, 500);
      setIsNotificationVisible(true);
      console.error('An error occurred while downloading data line csv:', error);
    },
    onSuccess: () => {
      console.log('Data Line csv downloaded successfully.');
    },
    ...config,
    mutationFn: getLineDownloadCsv,
  })
}